module.exports = __webpack_public_path__ + "static/media/dajianshanadj.cec7009a.webp";